<footer>
    <div class="container py-3">
        <div
            class="d-flex justify-content-between align-items-center flex-column flex-md-row border-bottom py-2"
        >
            <h3 class="ms-0 mb-0">
                <img
                    height="50"
                    alt="iChoosr logo"
                    [attr.src]="'footer-logo' | cmsImageSrc | async"
                    [attr.alt]="'footer-logo' | cmsImageAlt | async"
                />
            </h3>
            <ul class="nav justify-content-center">
                <li class="nav-item">
                    <a
                        class="nav-link text-white"
                        [routerLink]="[
                            '/',
                            communityCode,
                            languageCode,
                            'terms-and-conditions',
                        ]"
                        target="_blank"
                    >
                        {{ 'terms-and-conditions' | cmsText | async }}</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link text-white"
                        [routerLink]="[
                            '/',
                            communityCode,
                            languageCode,
                            'privacy-policy',
                        ]"
                        target="_blank"
                    >
                        {{ 'privacy-policy' | cmsText | async }}</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link text-white"
                        [routerLink]="[
                            '/',
                            communityCode,
                            languageCode,
                            'cookie-policy',
                        ]"
                        target="_blank"
                    >
                        {{ 'cookie-policy' | cmsText | async }}</a
                    >
                </li>
            </ul>
        </div>

        <div
            class="d-flex text-left justify-content-center align-items-center justify-content-md-start flex-column flex-md-row mx-3 mt-3"
        >
            <div class="d-flex mt-3 mt-md-0">
                <p class="mb-0 small text-white">
                    {{
                        'footer-copyright-text'
                            | cmsText: [{ year: year }]
                            | async
                    }}
                </p>
            </div>
        </div>
    </div>
</footer>
